import { NgModule } from '@angular/core';
import { ConfigOption, FormlyModule } from '@ngx-formly/core';
import { FormlyGeonamesAutocompleteComponent } from '../web/components/formly-types/geonames.type';
import { FormlyCountryAutocompleteComponent } from '../web/components/formly-types/formly-country-autocomplete';
import { RatingButtonsType } from '../web/components/formly-types/rating-buttons.component';
import { EmojiRatingType } from '../web/components/formly-types/emoji-rating.component';
import { FormlyGooglePlacesComponent } from '../web/components/formly-types/google-places-autocomplete.type';
import { FormlyMultiSelectComponent } from '../web/components/formly-types/multi-select.type';
import { MultiSocialInputComponent } from '../web/components/formly-types/company-socials.type';
import { FormlyFieldFile } from '../web/components/formly-types/file-type/file-type.component';
import { PhoneTypeComponent } from '../web/components/formly-types/phone-type/phone-type.component';
import { CustomRadioDescriptionType } from '../web/components/formly-types/CustomRadioDescriptionType';
import { FormlyCardTypeComponent } from '../web/components/formly-types/formly-card-type.component';
import { buildValidationMessages, } from '../web/components/error-message.service';
import { SwitchTypeComponent } from '../web/components/formly-types/switch-type';
import { PaymentMethodComponent } from '../web/components/formly-types/payment-method.type';


export const socialFields = ['fbLink', 'igLink', 'liLink', 'ytLink', 'twitterLink', 'website'];

export function requireAtLeastOneSocial(model: any): boolean {
  if (!model) return true; 
  const filledFields = socialFields.filter(field => model[field] && model[field].trim() !== '');
  return filledFields.length === 0;
}

export function atLeastOneSocialValidator(control: any): boolean {
    if (!control?.value) return false;
    return socialFields.some(field => control.value[field] && control.value[field].trim() !== '');
  }

export const formlyConfig: ConfigOption = {
    validationMessages: buildValidationMessages(),
    validators: [
        {
            name: 'exactTwoFiles',
            validation: (control: any) => {
                const valid = Array.isArray(control.value) && control.value.length === 2;
                return valid ? null : { exactTwoFiles: true };
            },
        },
    ],
    types: [
        { name: 'radio-description', component: CustomRadioDescriptionType },
        { name: 'card-selection', component: FormlyCardTypeComponent },
        { name: 'geo-autocomplete', component: FormlyGeonamesAutocompleteComponent },
        { name: 'country-autocomplete', component: FormlyCountryAutocompleteComponent },
        { name: 'rating-buttons', component: RatingButtonsType },
        { name: 'emoji-rating', component: EmojiRatingType },
        { name: 'google-places', component: FormlyGooglePlacesComponent },
        { name: 'multi-language-select', component: FormlyMultiSelectComponent },
        { name: 'multi-social-input', component: MultiSocialInputComponent },
        { name: 'file', component: FormlyFieldFile },
        { name: 'phone', component: PhoneTypeComponent },
        { name: 'switch', component: SwitchTypeComponent },
        { name: 'paymentMethod', component: PaymentMethodComponent },
    ],
};

@NgModule({
    imports: [
        FormlyModule.forRoot(formlyConfig)
    ],
})
export class FormlyConfigModule { }